import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import TrashIcon from '../../../Icons/TrashIcon/TrashIcon';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import ConfirmationPopup from '../../../ConfirmationPopup/ConfirmationPopup';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

import './ModerationDelete.scss';

const ModerationDelete = ({ hash }) => {
    const { getContent, deleteCommunityContent } = useContext(CommunityContext);
    const { isLoggedIn } = useContext(PageContext);
    const [showDeleteMenu, setShowDeleteMenu] = useState(false);

    const content = getContent(hash);

    const handleDeleteClick = useCallback(() => {
        if (!isLoggedIn()) return;
        EmitMetric({
            community_content_key: `${content.type}-${hash}`,
            misc_event_count: 1,
            misc_event_type: 'delete_content_clicked',
        });
        if (!showDeleteMenu) setShowDeleteMenu(true);
    }, [content.type, hash, isLoggedIn, showDeleteMenu]);

    const handleCloseDeleteModal = useCallback(() => {
        if (showDeleteMenu) setShowDeleteMenu(false);
    }, [showDeleteMenu]);

    const handleDelete = useCallback(() => {
        deleteCommunityContent(content.type, hash);
        handleCloseDeleteModal();
    }, [deleteCommunityContent, handleCloseDeleteModal, hash, content.type]);

    return (
        <>
            <div
                className="component-ModerationDelete"
                onClick={handleDeleteClick}
                onKeyPress={handleDeleteClick}
                role="button"
                tabIndex={0}
            >
                <TrashIcon />
                <span className="moderationDelete-label">Delete</span>
            </div>
            <div>
                {showDeleteMenu && (
                    <ConfirmationPopup
                        onClose={handleCloseDeleteModal}
                        cssClass="delete-confirmation"
                        heading={`Are you sure you want to delete this ${
                            content.type === 'community-comment'
                                ? 'comment'
                                : 'post'
                        }?`}
                        subheading="This cannot be undone."
                        imageSrc="v1562791783/EditDelete/deletemodule_trashcan.svg"
                        buttonMetas={[
                            {
                                onClickHandler: handleDelete,
                                buttonText: 'Yes',
                                buttonType: 'purple-medium-white',
                            },
                            {
                                onClickHandler: handleCloseDeleteModal,
                                buttonText: 'No',
                                buttonType: 'secondary-blue-gray',
                            },
                        ]}
                    />
                )}
            </div>
        </>
    );
};

ModerationDelete.propTypes = {
    hash: PropTypes.string.isRequired,
};
ModerationDelete.defaultProps = {};

ModerationDelete.displayName = 'ModerationDelete';

export default ModerationDelete;
